import React from "react";
import { Navigate } from "react-router-dom";
import ROUTES from "../config/routes";
import { useAuth } from "../features/auth/context/AuthContext";

export default function CompleteProfileGuard({ children }) {
  const { user, isAuthenticated, isHydratingAuth } = useAuth();

  if (isHydratingAuth) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  if (user?.profile_status === "complete") {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return children;
}
